<template>
    <div class="mt-3">
        <b-form-group label="Title">
            <b-form-select
                :class="{'has-error': errors.title}"
                v-model="userForm.title"
                :options="titles"
                @change="onFocus('title')"
                placeholder="Select title"
                >
            </b-form-select>
        </b-form-group>
        <b-form-group label="First Name" :class="{'has-error': errors.first_name}" >
            <input class="form-control"
                placeholder="Enter your first name"
                v-model="userForm.first_name"
                @focus="onFocus('first_name')">
        </b-form-group>
        <b-form-group label="Surname" :class="{'has-error': errors.last_name}" >
            <input class="form-control"
            placeholder="Enter your surname"
            v-model="userForm.last_name"
            @focus="onFocus('last_name')" >
        </b-form-group>
        <b-form-group label="Email Address" :class="{'has-error': errors.email}" >
            <input class="form-control"
                placeholder="Enter your email address"
                v-model="userForm.email"
                @focus="onFocus('email')" >
        </b-form-group>
        <b-form-group label="Telephone number" :class="{'has-error': errors.phone_number}" >
            <input class="form-control"
                placeholder="Enter your telephone number"
                autoComplete="tel"
                v-model="userForm.phone_number"
                @focus="onFocus('phone_number')" >
        </b-form-group>
        <b-form-group v-if="showPassword" label="Create Password" :class="{'has-error': errors.password}" >
            <input type="password"
                class="form-control"
                placeholder="Enter a password"
                v-model="userForm.password"
                autoComplete="new-password"
                @focus="onFocus('password')" >
        </b-form-group>
        <b-form-group v-if="showPassword" label="Confirm Password" :class="{'has-error': errors.password_confirmation}">
            <input type="password"
                class="form-control"
                placeholder="Confirm the password"
                autoComplete="off"
                v-model="userForm.password_confirmation"
                @focus="onFocus('password_confirmation')" >
        </b-form-group>
        <b-form-group label="Date of birth" class="planner-datepicker" :class="{'has-error': errors.dob}">
            <svg-icon class="time-picker-calendar c-pointer calendar-icon-home" name="time-picker-calendar-icon" width="18"></svg-icon>
            <datetime
                :week-start="1"
                v-model="userForm.dob"
                type="date"
                input-id="outbound-input"
                placeholder="choose your date of birth"
                input-class="form-control ajp-form-control datetime-picker-control c-pointer"
                class="theme-red"
                @focus="onFocus('dob')"
                :flow="['year', 'date']"
                aria-label="date-time-picker" >
            </datetime>
        </b-form-group>
        <b-form-group label="Do you have car access?">
            <b-row>
                <b-col cols="6" class="pr-0">
                    <button type="button" class="btn h-auto map-button-pill option-pill" :class="{'active': userForm.has_car_access}" @click="handleButtonChange('has_car_access', true)">
                        <strong>Yes</strong>
                    </button>
                </b-col>
                <b-col cols="6" class="pl-1">
                    <button type="button" class="btn h-auto option-pill" :class="{'active': !userForm.has_car_access}" @click="handleButtonChange('has_car_access', false)">
                        <strong>No</strong>
                    </button>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group label="Do you have a concessionary pass?">
            <b-row>
                <b-col cols="6" class="pr-0">
                    <button type="button" class="btn h-auto map-button-pill option-pill" :class="{'active': userForm.has_concessionary_pass}" @click="handleButtonChange('has_concessionary_pass', true)">
                        <strong>Yes</strong>
                    </button>
                </b-col>
                <b-col cols="6" class="pl-1">
                    <button type="button" class="btn h-auto option-pill" :class="{'active': !userForm.has_concessionary_pass}" @click="handleButtonChange('has_concessionary_pass', false)">
                        <strong>No</strong>
                    </button>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group label="Do you have a YoungScot card?">
            <b-row>
                <b-col cols="6" class="pr-0">
                    <button type="button" class="btn h-auto map-button-pill option-pill" :class="{'active': userForm.has_young_scot_card}" @click="handleButtonChange('has_young_scot_card', true)">
                        <strong>Yes</strong>
                    </button>
                </b-col>
                <b-col cols="6" class="pl-1">
                    <button type="button" class="btn h-auto option-pill" :class="{'active': !userForm.has_young_scot_card}" @click="handleButtonChange('has_young_scot_card', false)">
                        <strong>No</strong>
                    </button>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group v-if="userForm.has_young_scot_card" label="Is your YoungScot card issued since 10th January 2022?">
            <b-row>
                <b-col cols="6" class="pr-0">
                    <button type="button" class="btn h-auto map-button-pill option-pill" :class="{'active': userForm.has_new_young_scot_card}" @click="handleButtonChange('has_new_young_scot_card', true)">
                        <strong>Yes</strong>
                    </button>
                </b-col>
                <b-col cols="6" class="pl-1">
                    <button type="button" class="btn h-auto option-pill" :class="{'active': !userForm.has_new_young_scot_card}" @click="handleButtonChange('has_new_young_scot_card', false)">
                        <strong>No</strong>
                    </button>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group label="Do you have a Railcard?" :class="{'has-error': errors.railcard}">
            <b-row>
                <b-col cols="6" class="pr-0">
                    <button type="button" class="btn h-auto map-button-pill option-pill" :class="{'active': userForm.railcard}" @click="handleButtonChange('railcard', true)">
                        <strong>Yes</strong>
                    </button>
                </b-col>
                <b-col cols="6" class="pl-1">
                    <button type="button" class="btn h-auto option-pill" :class="{'active': !userForm.railcard}" @click="handleButtonChange('railcard', null)">
                        <strong>No</strong>
                    </button>
                </b-col>
            </b-row>
        </b-form-group>
        <div v-if="userForm.railcard">
            <div class="message">
                <p>Please select which of these railcards you have:</p>
            </div>
            <b-form-group>
                <b-form-radio-group v-model="userForm.railcard" :options="railcardOptions" class="mb-3" value-field="value" text-field="value" stacked >
                </b-form-radio-group>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'UserForm',
    props: {
        userForm: {
            required: true,
            type: Object,
        },
        showPassword: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            titles: [
                { value: null, text: 'Please select a title' },
                { value: 'Mr', text: 'Mr' },
                { value: 'Mrs', text: 'Mrs' },
                { value: 'Ms', text: 'Ms' },
                { value: 'Miss', text: 'Miss' },
                { value: 'Dr', text: 'Dr' },
                { value: 'Prof', text: 'Prof' },
                { value: 'Sir', text: 'Sir' },
                { value: 'Dame', text: 'Dame' },
                { value: 'Reverend', text: 'Reverend' },
                { value: 'Duke', text: 'Duke' },
                { value: 'Duchess', text: 'Duchess' },
                { value: 'Other', text: 'Other' },
            ],
            railcardOptions: [
                { value: '16-17 Saver' },
                { value: '16-25 Railcard' },
                { value: '26-30 Railcard' },
                { value: 'Disabled Persons Railcard' },
                { value: 'Senior Railcard' },
            ],
        }
    },
    computed: {
        ...mapState([
            'errors',
        ]),
    },
    methods: {
        ...mapMutations([
            'setError',
        ]),
        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },
        handleButtonChange(field, value) {
            this.userForm[field] = value

            if (field === 'has_young_scot_card' && value === false) {
                this.userForm.has_new_young_scot_card = false
            }
        },
    },
}
</script>
